import React from 'react'

import { DialogHeader } from '../../../main/components/dialog'
import FormContent from './FormContent'
import SuccessContent from './SuccessContent'

type CreateAlertProps = {
  ticker: string
  isInlined?: boolean
  onClose?: () => void
}

export function CreateAlert({ ticker, onClose, isInlined }: CreateAlertProps) {
  const [isSubmitted, setIsSubmitted] = React.useState(false)

  const handleFromSubmitted = () => {
    if (isInlined) {
      // @ts-ignore
      window.location = '/alerts.ashx'
      return
    }

    setIsSubmitted(true)
  }

  return (
    <>
      <DialogHeader onCloseClick={onClose}>Create Alert</DialogHeader>

      {isSubmitted ? (
        <SuccessContent onClose={onClose} />
      ) : (
        <FormContent ticker={ticker} onClose={onClose} onSubmit={handleFromSubmitted} />
      )}
    </>
  )
}
